__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/92e6ff0/packs/";